<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن لینک به شماره</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>لینک</label>
                                    <model-select :options="links" v-model="form.url_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.url_id.inv}}</small>
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: {val: '', inv: '', v: { req: true, max: 8 }},
				url_id: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            links: [],
            users: [],
        }
    },
    watch: {
        'form.user_id.val': {
            handler(){
                if(this.form.user_id.val != ''){
                    this.get_links();
                }
            }
        }
    },
    mounted() {
        this.get_users();
	},
    methods: {
        get_users(){
            this.axios.get('users/?type=add_user_link_to_nums')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_links(){
            this.axios.get('user_urls/'
                + '?user_id=' + this.form.user_id.val)
                .then(res => {
                    this.links = [];
                    res.data.map(val => {
                        this.links.push({value: val.id, text: val.url_link})
                    });
                })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                data.set('url_id', this.form.url_id.val);
                data.set('user_num_id', this.$route.params.id);
                this.axios.post('url_to_nums/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_link_to_nums == false
            && this.$store.state.perms.can_add_link_to_nums_for_all_user == false
            && this.$store.state.perms.can_add_link_to_nums_for_same_group_user == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
